
export default {
  methods: {
    returnResultsText(length) {
      var resultsText = this.$t("text.results");

      if (length % 10 == 1) {
        resultsText = this.$t("text.result");
      }

      return resultsText;
    },
  },
};
